// @ts-strict-ignore
import React from "react";
import Slider from "react-slick";
import {
  TrendingTokensContainer,
  TrendingTokensSliderContainer
} from "./style";
import { TrendingTokenCardComponent } from "components/parts/TrendingTokenCard";
import type { TrendingCoinObj } from "types/howToBuy-type";
import { getIcon } from "utils/currencies/icon";
import { useTranslations } from "i18n";
import { Colors } from "themes/color-palette";
import { HubbleDisplay } from "components/parts/Typography";

interface TrendingTokensComponentProps {
  trendingCoins: Array<TrendingCoinObj>;
}

const TrendingTokens = (props: TrendingTokensComponentProps) => {
  const { trendingCoins } = props;
  const t = useTranslations("how-to-buy");

  const settings = {
    variableWidth: true,
    dots: false, // Hide dots on desktop
    arrows: false,
    slidesToShow: trendingCoins.length / 2, // Display 1 card per slide on desktop
    slidesToScroll: 1, // Move 1 card at a time
    responsive: [
      {
        breakpoint: 768, // Adjust the breakpoint as needed
        settings: {
          dots: true,
          slidesToShow: 2, // Display 2 cards per slide on mobile,
          slidesToScroll: 2, // Move 2 cards at a time,
          customPaging: () => {
            return <div className="dot"></div>;
          },
          dotsClass: "slick-dots slick-thumb"
        }
      }
    ]
  };

  const generateTokenCards = (): Array<any> => {
    return trendingCoins?.map((trendingCoin: TrendingCoinObj) => {
      return (
        <TrendingTokenCardComponent
          key={trendingCoin.name}
          slug={trendingCoin.slug}
          coinSymbol={trendingCoin.coin}
          coinChange={parseFloat(trendingCoin["24hrPercentDelta"])}
          coinPrice={trendingCoin.ask}
          coinImgUrl={getIcon(trendingCoin?.coin?.toLowerCase())}
        />
      );
    });
  };

  return (
    <TrendingTokensContainer>
      <HubbleDisplay as="h2" size="lg" bold color={Colors.gray[600]} mb={4}>
        {t("trendingTokensTitle")}
      </HubbleDisplay>
      <TrendingTokensSliderContainer className="trending-tokens-slider-container">
        <Slider {...settings} swipeToSlide={true}>
          {generateTokenCards()}
        </Slider>
      </TrendingTokensSliderContainer>
    </TrendingTokensContainer>
  );
};
export default TrendingTokens;
